<template>
  <div class="login auth-page">
    <van-nav-bar class="auth-nav" :title="$t('auth.login')">
      <template #left>
        <van-icon name="arrow-left" aria-label="Back" @click="back()" />
      </template>
      <template #right>
        <button class="language" type="button" aria-label="Choose language" @click="$router.push('/language')">
          <img :src="require('../images/language/' + lang + '.png')" alt="">
        </button>
      </template>
    </van-nav-bar>

    <main class="auth-content">
      <VictoriaBrand compact />

      <section class="auth-form" aria-label="Login form">
        <van-field
          v-model="username"
          clearable
          class="auth-field"
          autocomplete="username"
          :placeholder="$t('auth.username_place')"
        >
          <template #left-icon>
            <van-icon name="user-o" aria-hidden="true" />
          </template>
        </van-field>

        <van-field
          v-model="password"
          :type="passwordType"
          class="auth-field"
          autocomplete="current-password"
          :placeholder="$t('auth.pwd_place')"
        >
          <template #left-icon>
            <van-icon name="lock" aria-hidden="true" />
          </template>
          <template #right-icon>
            <van-icon
              :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
              aria-label="Toggle password visibility"
              @click="switchPasswordType"
            />
          </template>
        </van-field>

        <button class="register-link" type="button" @click="toRegister()">
          {{$t("auth.no_account")}}
        </button>

        <van-button class="auth-submit" type="primary" size="normal" @click="doLogin()">
          {{$t("auth.login")}}
        </van-button>
      </section>
    </main>
  </div>
</template>

<script>
import VictoriaBrand from '../../common/VictoriaBrand'

export default {
  components: {
    VictoriaBrand
  },
  model: {
    prop: "inputValue",
    event: "input",
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      username: "",
      lang: 'en_us',
      password: this.inputValue,
      passwordType: "password",
    };
  },
  mounted(){
    // localStorage.setItem("lang", 'ms_my');
    this.lang = localStorage.getItem("lang") || 'th_th';
  },
  methods: {
    switchPasswordType() {
      this.passwordType =
          this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    toRegister() {
      this.$router.push("Register");
    },
    doLogin() {
      if (
          this.username === "" ||
          this.username === null ||
          this.username === undefined
      ) {
        this.$toast(this.$t("auth.username_place"));
        return false;
      }
      if (
          this.password === "" ||
          this.password === null ||
          this.password === undefined
      ) {
        this.$toast(this.$t("auth.pwd_place"));
        return false;
      }
      this.$http({
        url: "member_login",
        method: "post",
        data: {
          username: this.username,
          password: this.password,
          lang: this.lang
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          this.$router.push("home");
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang='less' scoped>
.auth-page {
  position: relative;
  min-height: 100%;
  overflow-y: auto;
  background-image:
    linear-gradient(180deg, rgba(7, 6, 8, 0.18) 0%, rgba(8, 6, 9, 0.08) 52%, rgba(8, 6, 9, 0.5) 100%),
    url('/img/victoria/auth-bg.png');
  background-position: center bottom;
  background-repeat: no-repeat;
  background-size: cover;
  color: var(--victoria-text);
}

.auth-nav {
  background: transparent;
}

::v-deep .auth-nav::after {
  display: none;
}

::v-deep .auth-nav .van-nav-bar__title,
::v-deep .auth-nav .van-icon {
  color: var(--victoria-text) !important;
}

::v-deep .auth-nav .van-nav-bar__title {
  font-size: 0.4rem !important;
  font-weight: 500 !important;
  text-transform: capitalize;
}

.language {
  width: 0.8rem;
  height: 0.8rem;
  padding: 0.07rem;
  overflow: hidden;
  background: rgba(20, 16, 21, 0.66);
  border: 1px solid var(--victoria-border);
  border-radius: 50%;
}

.language img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.auth-content {
  display: flex;
  flex-direction: column;
  min-height: calc(100% - 1.22667rem);
  padding: 0.15rem 0.72rem calc(0.9rem + env(safe-area-inset-bottom));
}

::v-deep .victoria-brand__logo {
  border: 1px solid rgba(231, 160, 174, .66);
  border-radius: 50%;
  box-shadow: inset 0 0 .52rem rgba(231, 160, 174, .06), 0 0 .48rem rgba(231, 160, 174, .12);
}

.auth-form {
  display: grid;
  gap: 0.38rem;
  margin-top: 0.74rem;
}

.auth-field {
  --auth-field-height: 1.3rem;
  display: flex;
  height: var(--auth-field-height);
  min-height: 1.3rem;
  padding: 0 0.46rem;
  align-items: center;
  color: var(--victoria-text);
  background: rgba(20, 17, 21, 0.8);
  border: 1px solid rgba(231, 160, 174, 0.24);
  border-radius: 0.68rem;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035), 0 0.18rem 0.5rem rgba(0, 0, 0, 0.18);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.auth-field:focus-within {
  border-color: rgba(255, 209, 217, 0.7);
  box-shadow: 0 0 0 0.08rem rgba(231, 160, 174, 0.12), 0 0.22rem 0.6rem rgba(0, 0, 0, 0.22);
}

::v-deep .auth-field::after {
  display: none;
}

::v-deep .auth-field .van-field__control {
  height: 100%;
  padding: 0;
  color: var(--victoria-text);
  font-size: 0.35rem;
  line-height: var(--auth-field-height);
}

::v-deep .auth-field .van-field__control::placeholder {
  color: rgba(248, 241, 243, 0.58);
}

::v-deep .auth-field .van-field__left-icon,
::v-deep .auth-field .van-field__right-icon {
  display: inline-flex;
  height: 100%;
  align-items: center;
  color: var(--victoria-primary);
  font-size: 0.49rem;
  line-height: normal;
}

::v-deep .auth-field .van-cell__value,
::v-deep .auth-field .van-field__body {
  height: 100%;
}

::v-deep .auth-field .van-field__body {
  align-items: center;
}

::v-deep .auth-field .van-field__clear {
  display: inline-flex;
  height: 100%;
  align-items: center;
}

.register-link {
  justify-self: center;
  padding: 0.08rem 0.18rem;
  color: var(--victoria-light-rose);
  font-size: 0.31rem;
  line-height: 1.5;
  background: transparent;
  border: 0;
}

.auth-submit {
  width: 100%;
  height: 1.34rem;
  margin-top: 0.16rem;
  color: #28191e;
  font-size: 0.37rem;
  font-weight: 700;
  letter-spacing: 0.06rem;
  text-transform: uppercase;
  background: var(--victoria-action);
  border: 0;
  border-radius: 0.7rem;
  box-shadow: 0 0.25rem 0.7rem rgba(207, 127, 145, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.32);
}

@media (max-height: 680px) {
  .auth-content {
    padding-top: 0;
  }

  .auth-form {
    margin-top: 0.4rem;
  }
}
</style>
